export default "__VITE_ASSET__5ca388d3__"